import { FleetDimension } from '@cnx-saas/carrier-management';

export { VehicleCapabilities as VehicleCapability } from '@cnx-saas/vehicles';

export enum VehicleEquipment {
  HYDRAULIC_RAMP = 'HYDRAULIC_RAMP',
  ELECTRIC_PALLET_TRUCK = 'ELECTRIC_PALLET_TRUCK',
  FORKLIFT_LICENCE = 'FORKLIFT_LICENCE',
  FRIGO = 'FRIGO',
}

export interface ShipmentVehicle {
  referenceId?: string;
  vehicleType?: string;
  vehicleLicense?: string;
  trailerLicense?: string;
  dimension?: FleetDimension[];
  name?: string;
}
